import ApiService from '../ApiService'

const calendarService = {

    create (data) {
      return ApiService.post('/calendar-configuration-appointment/', data)
    },

    edit (data) {
      return ApiService.post('/calendar-configuration-appointment/edit', data)
    },

    getAllowedDates (deliveryPoint, userIsAdmin) {
      return ApiService.get(`/calendar-configuration-appointment/getAllowedDates?deliveryPoint=${deliveryPoint}&userIsAdmin=${userIsAdmin}`)
    },

    getScheduleRanges (id, userIsAdmin) {
      return ApiService.get(`/calendar-configuration-appointment/getScheduleRanges?id=${id}&userIsAdmin=${userIsAdmin}`)
    },

    getCalendarConfiguration (data) {
      return ApiService.post(`/calendar-configuration-appointment/getCalendarConfiguration`, data)
    }
}

export default calendarService
